module.exports = __webpack_public_path__ + "static/media/ClinicaBazterrica.c9d45d15.svg";